import { useState } from "react";
// import apiRequest from "../../lib/apiRequest";

import "./slider.scss";
import arrow from "../../assets/arrow.png";
import home3 from "../../assets/home3.png";
import nohome from "../../assets/nohome.png";
import { isLocalhost } from "../../../checkLocalhost";
// import { imageType } from "tesseract.js";

import { Image_profiles } from "../../lib/constants";

// ImageType constants



function Slider({ images=[], postid ,projectid,userid,builderpost,ImageType=Image_profiles.POST}) {


// Example base paths
// const builderimageslocation = isLocalhost
//   ?import.meta.env.VITE_SERVER_BASEURL+'/projects/'
//   :import.meta.env.VITE_SH_DSERVER_BASEURL+'/project/'

// const postimageslocation =isLocalhost
//   ?import.meta.env.VITE_POSTIMAGES_BASEURL+userid+"/posts/"
//   :import.meta.env.VITE_POSTIMAGES_SH_BASEURL+userid+"/posts/"


// console.log("Slider images:", images);
// console.log("Slider ImageType:", ImageType);






const profileimageslocation =isLocalhost
  ?import.meta.env.VITE_POSTIMAGES_BASEURL+userid+"/posts/"
  :import.meta.env.VITE_POSTIMAGES_SH_BASEURL+userid+"/posts/"

const adsimageslocation = "https://example.com/ads/";


  const [imageIndex, setImageIndex] = useState(null);
  // const [selectedImage, setSelectedImage] = useState(images?.length > 0 ? images[0] : nohome);
  // const [smallImages, setSmallImages] = useState(images?.slice(1));




//  const postimageslocation = import.meta.env.VITE_IS_LOCALHOST=='true'
  const postimageslocation = isLocalhost
  ?import.meta.env.VITE_POSTIMAGES_BASEURL+userid+"/posts/"
  :import.meta.env.VITE_POSTIMAGES_SH_BASEURL+userid+"/posts/"


const projectimageslocation = isLocalhost
  ?import.meta.env.VITE_PROJECTIMAGES_BASEURL+projectid+"/"
  :import.meta.env.VITE_PROJECTIMAGES_SH_BASEURL+projectid+"/"


  // const builderimageslocation=import.meta.env.VITE_IS_LOCALHOST=='true'
  // ?"http://localhost:5173/"
  // :"http://fulcrumengineers.in/"


//  const builderimageslocation=import.meta.env.VITE_IS_LOCALHOST=='true'
  const builderimageslocation=isLocalhost
  ?import.meta.env.VITE_SERVER_BASEURL+'/'
  :import.meta.env.VITE_SH_DSERVER_BASEURL+'/'

// Base path mapping
const IMAGE_BASE_PATH = {
  [Image_profiles.PROFILE]: profileimageslocation,
  [Image_profiles.POST]: postimageslocation,
  [Image_profiles.PROJECT]: projectimageslocation,
  [Image_profiles.ADVERTISEMENT]: adsimageslocation
};


const getImageSrc = (imageObj, builderpost = false) => {
  if (!imageObj?.image) return "";

  // 1️⃣ External URL
  if (imageObj.image.startsWith("http")) return imageObj.image;

  // 2️⃣ Determine ImageType (default = Post)
  const type = ImageType || Image_profiles.POST;
  // console.log("Determined ImageType:", type);

  // 3️⃣ Determine base path
  const basePath = builderpost
    ? builderimageslocation     // builderpost overrides everything
    : IMAGE_BASE_PATH[type] || postimageslocation;

  return `${basePath}${imageObj.image}`;
};


const imagesWithLocation = (images || []).map(img => ({
  ...img,
  imagelocation: getImageSrc(img, builderpost)
}));

  const [selectedImage, setSelectedImage] = useState(
    imagesWithLocation.length > 0 ? imagesWithLocation[0] : null
  );

  const [smallImages, setSmallImages] = useState(
    imagesWithLocation.slice(1)
  );



// Helper function to generate image URL


  // Function to update prime image on the server
  const updateImageIndexOnServer = async (image) => {
    // console.log('Updating image index:', image);
    try {
      // const imageid = images.indexOf(image) + 1; // Assuming 1-based ID
      const imageid=image.id
      
      // make code for apirequest
      
      // await axios.post(
      //   // SERVER_DBASEURL+"/api/posts/prime",
      //   SERVER_DBASEURL+"/posts/prime",
      //   {
      //     postid,
      //     imageid,
      //   },
      //   {
      //     withCredentials: true, // Ensures cookies (including token) are sent
      //   }
      // );

      // console.log(`Updated prime image on server: postid=${postid}, imageid=${imageid}`);
    } catch (error) {
      console.error("Failed to update image index:", error);
    }
  };

  // Function to change slide in full-screen mode
  const changeSlide = (direction) => {
    let newIndex;
    if (direction === "left") {
      newIndex = imageIndex === 0 ? images.length - 1 : imageIndex - 1;
    } else {
      newIndex = imageIndex === images.length - 1 ? 0 : imageIndex + 1;
    }
    setImageIndex(newIndex);
    // updateImageIndexOnServer(images[newIndex]); // Update server
  };

  // Swap big image with clicked small image
  const handleSmallImageClick = (newBigImage) => {
    const updatedSmallImages = smallImages.filter((img) => img !== newBigImage);
    updatedSmallImages.unshift(selectedImage);
    setSelectedImage(newBigImage);
    setSmallImages(updatedSmallImages);
    // updateImageIndexOnServer(newBigImage); // Update server
  };

  return (
    <div className="slider">

      <div className="fullImageContainer">

        {/* Full-Screen Mode */}
        {imageIndex !== null && (

        <div className="fullSlider">
            <div className="arrow" onClick={() => changeSlide("left")}>
              <img src={arrow} alt="Left Arrow" />
            </div>

<div className="imgContainer">
  {(() => {
    const currentImage = imagesWithLocation[imageIndex];
    if (!currentImage) return null;

    return currentImage.file_type === "video" ? (
      <video
        src={currentImage.imagelocation}
        controls
        autoPlay
        style={{ width: "100%", maxHeight: "80vh" }}
      />
    ) : (
      <img
        src={currentImage.imagelocation}
        alt="Full Screen"
        style={{ width: "100%", maxHeight: "80vh" }}
      />
    );
  })()}
</div>



            <div className="arrow" onClick={() => changeSlide("right")}>
              <img src={arrow} className="right" alt="Right Arrow" />
            </div>
            <div className="close" onClick={() => setImageIndex(null)}>X</div>
          </div>
        )}

        {/* Big Image Display */}

        {/* Big Image */}
<div className="bigImage">
  {selectedImage?.image ? (
    selectedImage.file_type === "video" ? (
      <video
        src={selectedImage.imagelocation}
        controls
        autoPlay
        // style={{ width: "100%", maxHeight: "80vh" }}
        onClick={() => {
          const newIndex = imagesWithLocation.findIndex(
            img => img.image === selectedImage.image
          );
          setImageIndex(newIndex);
        }}
      />
    ) : (
      <img
        src={selectedImage.imagelocation}
        alt="Main"
        onClick={() => {
          const newIndex = imagesWithLocation.findIndex(
            img => img.image === selectedImage.image
          );
          setImageIndex(newIndex);
        }}
      />
    )
  ) : (
    <img src={home3} alt="No image available" />
  )}
</div>


        {/* Small Images */}

        {smallImages.length > 0 && (

          <div className="SmallImagesContainer">
            
<div className="smallImages">
  {Array.isArray(smallImages) &&
    smallImages.map((image, index) => {
      if (!image?.image) return null;

      const isVideo = image.file_type === "video"; // detect video

      return isVideo ? (
        <video
          key={image.id || index}
          src={image.imagelocation}
          width={80}       // thumbnail size
          height={60}
          onClick={(e) => {
            e.stopPropagation();
            handleSmallImageClick(image);
          }}
          style={{
            border: selectedImage === image ? "3px solid blue" : "2px solid gray",
            cursor: "pointer",
            borderRadius: "8px"
          }}
          muted
          loop
        />
      ) : (
        <img
          key={image.id || index}
          src={image.imagelocation}
          alt={`Thumbnail ${index + 1}`}
          onClick={(e) => {
            e.stopPropagation();
            handleSmallImageClick(image);
          }}
          style={{
            border: selectedImage === image ? "3px solid blue" : "2px solid gray",
            cursor: "pointer",
            borderRadius: "8px"
          }}
        />
      );
    })}
</div>



          </div>
          )
        }
      </div>
    </div>
  );
}

export default Slider;
